import { Price } from '@/interfaces/price';
import { BackendGridPriceResume } from '@/interfaces/BackendGridPriceResume';
import { TaxedPrice } from '@/classes/TaxedPrice';

export class GridPriceResume {
  public readonly totalCost: TaxedPrice;
  public readonly averagePricePerMWh: TaxedPrice;
  public readonly feeCost: TaxedPrice;
  public readonly consumptionCost: TaxedPrice;
  public readonly totalCostPerPrice: Price[];

  public constructor(ecoGridResume: Partial<BackendGridPriceResume>) {
    this.feeCost = new TaxedPrice(ecoGridResume.feeCostHT, ecoGridResume.feeCostTTC, '$');
    this.consumptionCost = new TaxedPrice(ecoGridResume.consumptionCostHT, ecoGridResume.consumptionCostTTC, '$');
    this.totalCost = new TaxedPrice(ecoGridResume.totalCostHT, ecoGridResume.totalCostTTC, '$');
    this.averagePricePerMWh = new TaxedPrice(ecoGridResume.averagePricePerMWhHT, ecoGridResume.averagePricePerMWhTTC, '$/MWh');
    this.totalCostPerPrice = ecoGridResume.consumptionCostHTPerPrice ?? [];
  }
}
